import React from 'react';
import { Avatar } from '../../shared/Avatar';
import { MasteryBar } from '../../shared/MasteryBar';
import type { SchoolData } from './types';
interface SchoolDetailPanelProps {
  school: SchoolData;
}
export function SchoolDetailPanel({
  school
}: SchoolDetailPanelProps) {
  return <div className="space-y-6" data-id="element-7530" data-mp="3ov5rncby5qsv">
      <div className="grid grid-cols-3 gap-3" data-id="element-7531" data-mp="3oue84zvmjjiy">
        <div className="bg-purple-50 rounded-lg p-3 text-center" data-id="element-7532" data-mp="3ot320tephzoo">
          <div className="text-2xl font-bold text-purple-700" data-id="element-7533" data-mp="2s6q05apa17d4">
            {school.learnerCount}
          </div>
          <div className="text-xs text-purple-600" data-id="element-7534" data-mp="2x4hqw1e6qnfq">Leerlingen</div>
        </div>
        <div className="bg-indigo-50 rounded-lg p-3 text-center" data-id="element-7535" data-mp="3151pzaibk14i">
          <div className="text-2xl font-bold text-indigo-700" data-id="element-7536" data-mp="35x39nhhtgu4k">
            {school.teacherCount}
          </div>
          <div className="text-xs text-indigo-600" data-id="element-7537" data-mp="29fgn4rgas0gs">Docenten</div>
        </div>
        <div className="bg-emerald-50 rounded-lg p-3 text-center" data-id="element-7538" data-mp="2dg0jvtwyl22e">
          <div className="text-2xl font-bold text-emerald-700" data-id="element-7539" data-mp="2de5zcgplnbyu">
            {school.avgMastery}%
          </div>
          <div className="text-xs text-emerald-600" data-id="element-7540" data-mp="3351fltzgcg6t">Gem. beheersing</div>
        </div>
      </div>

      {school.teachers.length > 0 && <div data-id="element-7541" data-mp="2yd9lxal01ucg">
          <h3 className="text-sm font-semibold text-gray-900 mb-3" data-id="element-7542" data-mp="2yd05adlugzjf">Docenten</h3>
          <div className="space-y-1" data-id="element-7543" data-mp="2tfzxny9cjoq7">
            {school.teachers.map(t => <div key={t.id} className="flex items-center gap-2 py-1.5" data-id="element-7544" data-mp="2ogn3esg5bfdl">
                <Avatar name={t.name} data-id="element-7545" data-mp="2odslb7klu6nc" />
                <span className="text-sm text-gray-700" data-id="element-7546" data-mp="2kea6mtjdmrsy">{t.name}</span>
              </div>)}
          </div>
        </div>}

      {school.learners.length > 0 && <div data-id="element-7547" data-mp="2agvu350kqn5x">
          <h3 className="text-sm font-semibold text-gray-900 mb-3" data-id="element-7548" data-mp="2ah5n71gx1afu">
            Leerlingen
          </h3>
          <div className="space-y-2" data-id="element-7549" data-mp="dn13klve7mp9">
            {school.learners.map(learner => <div key={learner.id} className="flex items-center justify-between py-2 border-b border-gray-50 last:border-0" data-id="element-7550" data-mp="8optqb53lc71">
                <div className="flex items-center gap-2" data-id="element-7551" data-mp="27vxwhs1xb91q">
                  <Avatar name={learner.name} data-id="element-7552" data-mp="27xhdjkvelo4k" />
                  <div data-id="element-7553" data-mp="1t79yzg8iop95">
                    <div className="text-sm text-gray-800" data-id="element-7554" data-mp="1t82ypx926ehs">{learner.name}</div>
                    <div className="text-xs text-gray-400" data-id="element-7555" data-mp="1y5ldi49rbnxp">
                      {learner.account && 'grade' in learner.account ? `Groep ${learner.account.grade}` : '—'}{' '}
                      · {learner.sessionCount} sessies
                    </div>
                  </div>
                </div>
                <MasteryBar value={learner.avgMastery || 0} data-id="element-7556" data-mp="2bx9og489s6d3" />
              </div>)}
          </div>
        </div>}
    </div>;
}